import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Droplets, FlaskConical } from 'lucide-react';
export function AgitationSection() {
  return <section className="py-12 md:py-20 px-6 bg-white" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="space-y-6 md:space-y-12" data-id="element-13">
          <div className="text-center mb-8 md:mb-16" data-id="element-14">
            <h2 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6" data-id="element-15">
              El Círculo Vicioso de la Inflamación
            </h2>
            <div className="w-24 h-1 bg-gold mx-auto" data-id="element-16"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-5 md:gap-8" data-id="element-17">
            <div className="bg-cream p-6 md:p-8 rounded-xl border border-gold/10 hover:border-gold/30 transition-colors" data-id="element-18">
              <AlertTriangle className="w-10 h-10 text-gold mb-4 md:mb-6" data-id="element-19" />
              <h3 className="text-xl font-bold mb-3 md:mb-4 font-serif" data-id="element-20">
                Frustración Constante
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-21">
                Gastas la mitad de tu sueldo en el "suero milagroso" que viste
                en redes, solo para despertar con la cara roja, irritada o
                exactamente igual que antes.
              </p>
            </div>

            <div className="bg-cream p-6 md:p-8 rounded-xl border border-gold/10 hover:border-gold/30 transition-colors" data-id="element-22">
              <Droplets className="w-10 h-10 text-gold mb-4 md:mb-6" data-id="element-23" />
              <h3 className="text-xl font-bold mb-3 md:mb-4 font-serif" data-id="element-24">
                Dinero al Desagüe
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-25">
                Sientes que estás tirando el dinero mientras las arrugas finas y
                las manchas de sol parecen reírse de tu rutina de 12 pasos.
              </p>
            </div>

            <div className="bg-cream p-6 md:p-8 rounded-xl border border-gold/10 hover:border-gold/30 transition-colors" data-id="element-26">
              <FlaskConical className="w-10 h-10 text-gold mb-4 md:mb-6" data-id="element-27" />
              <h3 className="text-xl font-bold mb-3 md:mb-4 font-serif" data-id="element-28">
                Experimento sin Mapa
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-29">
                Compras productos demasiado fuertes, destruyes tu barrera
                cutánea, y luego compras más productos caros para intentar
                "reparar" el daño.
              </p>
            </div>
          </div>

          <div className="bg-charcoal text-cream p-6 md:p-12 rounded-2xl text-center shadow-2xl mt-6 md:mt-12" data-id="element-30">
            <p className="text-xl md:text-2xl font-serif italic leading-relaxed" data-id="element-31">
              "Es caro, es agotador y, sinceramente, tu piel merece algo mejor
              que ser un experimento de laboratorio sin mapa."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}